const { useContext } = require("react");
const { AppContext } = require("src/context/AppContext");

const useApp = () => useContext(AppContext);

export default useApp;
